import { CLASSES } from "@/scripts/helpers/constants";

export const introTogglerModal = () => {
  const body = $("body"),
        formButton = $(".js-editor-link"),
        modalFormVers = $(".modal-animation-slide"),
        modalMore = $(".modal__more"),
        modalTrigger = $("[data-micromodal-trigger]"),
        modalOldVers = $(".modal__old-versions"),
        lockClassName = "scroll-locked",
        animationDuration = 350;

  if (formButton.length) {
    formButton.on("click", function(event) {
      event.preventDefault();
      
      let formVersionId = $(this).attr("data-formversionid");

      $(".page-section--greeting, .page-section--intro").attr('data-formid', formVersionId);
    });
  }

  modalTrigger.click(function (e) {
    body.addClass(lockClassName);
  });

  formButton.click(function (e) {
    modalFormVers.addClass(CLASSES.IS_HIDDEN);
  });

  modalMore.click(function (e) {
    e.preventDefault();

    modalFormVers.toggleClass(CLASSES.IS_SHOW);    
    setTimeout(() => {
      modalOldVers.slideToggle();
      $(this).text($(this).text() == "See old versions" ? "Hide" : "See old versions");
      $(this).toggleClass(CLASSES.IS_ACTIVE);
    }, animationDuration);
  });
};